import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { MenuDetailsSettings } from "./menu.details.model";
//3 attributes
export class MenuDetailsSettingsBuilder {
  private _instructions: string;
  private _warning: string;
  private _heroImage: string;

  constructor() {
    this.default();
  }

  private default(): void {
    this._instructions =
      "Show bartender pass for proof of order.\nPlease redeem this pass yourself.";
    this._warning = "Stop!\nOnly redeem if you have received your drinks.";
    this._heroImage =
      "https://firebasestorage.googleapis.com/v0/b/lineleap-e8561.appspot.com/o/venue_images%2Fsergio-alves-santos-PeDrafNlY2Y-unsplash.png?alt=media&token=923ab97e-d217-4646-bf80-622b5c81b57e";
  }

  public get instructions(): string {
    return this._instructions;
  }
  public set instructions(instructions: string) {
    this._instructions = instructions;
  }
  public get warning() {
    return this._warning;
  }
  public set warning(warning: string) {
    this._warning = warning;
  }
  public get heroImage(): string {
    return this._heroImage;
  }
  public set heroImage(heroImage: string) {
    this._heroImage = heroImage;
  }

  public load(data: DocumentData): MenuDetailsSettingsBuilder {
    this._instructions = data.instructions;
    this._heroImage = data.heroImage;
    this._warning = data.warning;
    return this;
  }

  public edit(data: MenuDetailsSettings): MenuDetailsSettingsBuilder {
    this._heroImage = data.heroImage;
    this._instructions = data.instructions;
    this._warning = data.warning;
    return this;
  }

  public build(): MenuDetailsSettings {
    return new MenuDetailsSettings(this);
  }

  public toJSON = () => ({
    instructions: this.instructions,
    warning: this.warning,
    heroImage: this.heroImage
  });
}
